export default __webpack_public_path__ + "static/media/it.33e84b24.svg";